<app-modal>
  <ng-container class="title">
    {{ 'account.securityWarning' | transloco | uppercase }}
  </ng-container>
  <ng-container class="actions">
    <button type="button" class="button-tertiary" aria-label="Close" (click)="dismiss()">
      {{ 'action.close' | transloco | uppercase }}
    </button>
  </ng-container>

  <ng-container class="content">
    <div>
      <p [innerHTML]="'account.mfa.popupWarning.explanationText' | transloco"></p>
      <p [innerHTML]="'account.mfa.popupWarning.recommendationText' | transloco"></p>
    </div>
    <div *ngIf="dismissable" class="d-flex align-items-center">
      <input id="stopMfaReminder" type="checkbox" class="form-check-input" [formControl]="stopMfaReminder"/>
      <label for="stopMfaReminder" class="form-check-label">
        {{ 'account.mfa.popupWarning.stopReminderText' | transloco }}
      </label>
    </div>
    <div *ngIf="showStopMfaReminderWarning$ | async">
      <hr/>
      <p class="warningText" [innerHTML]="'account.mfa.popupWarning.stopReminderWarningText' | transloco"></p>
      <p>
        {{ 'account.mfa.popupWarning.stopReminderSuggestionText1' | transloco }}
        <a href="./portal/profile/mfa" target="_blank"> {{ 'account.mfa.popupWarning.stopReminderSuggestionText2' | transloco }}</a>
      </p>
    </div>
    <div class="d-flex justify-content-center mt-3">
      <button type="button" class="button-primary" (click)="enableMfa()">{{ 'action.enable' | transloco }}</button>
    </div>
  </ng-container>
</app-modal>
